function isArrowDown (event) {
  return event.key === 'ArrowDown' || event.code === 'ArrowDown';
}

function isArrowUp (event) {
  return event.key === 'ArrowUp' || event.code === 'ArrowUp';
}

function isBackspace (event) {
  return event.key === 'Backspace' || event.code === 'Backspace';
}

function isEnter (event) {
  return event.key === 'Enter' || event.code === 'Enter';
}

export {
  isArrowDown,
  isArrowUp,
  isBackspace,
  isEnter,
};
